var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuForm',{attrs:{"url":_vm.url,"routes":_vm.routes,"menu":_vm.menu,"errors":_vm.errors},on:{"onUpdateMenu":_vm.onUpdateMenu,"save":_vm.saveMenu}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746144e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/menu/MenuCreate.vue
// module id = null
// module chunks = 